import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { browserStorage } from '../../utils/browserStorage.util';

const storedPageForRedirection: string[] = [
  pageInfo.productDetailPage.path,
  pageInfo.productListPage.path,
  pageInfo.infoDetailPage.path,
  pageInfo.infoListPage.path,
  pageInfo.openMarketListPage.path,
  pageInfo.openMarketDetailPage.path,
  pageInfo.homePage.path,
  pageInfo.sellTractorEntryPage.path,
];

export const useStorePageToRedirection = () => {
  const location = useLocation();

  useEffect(() => {
    let haveToStoreCurrentPage = false;

    storedPageForRedirection.forEach((pagePath) => {
      if (location.pathname.includes(pagePath)) {
        haveToStoreCurrentPage = true;
      }
    });

    if (haveToStoreCurrentPage) {
      browserStorage.setItem({
        storageType: 'sessionStorage',
        itemKey: 'storedPageForRedirection',
        value: location.pathname,
      });
    }
  }, [location.pathname]);
};
